/**
 * Converts an object to FormData recursively
 * @param obj The object to convert
 * @param form The FormData instance to use (creates a new one by default)
 * @param namespace The namespace for nested properties
 * @returns The FormData instance with all object properties added
 */
export function objectToFormData(obj: Record<string, any>, form = new FormData(), namespace = ''): FormData {
  for (let key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

    const formKey = namespace ? `${namespace}[${key}]` : key;
    const value = obj[key];

    if (value instanceof Date) {
      form.append(formKey, value.toISOString());
    } else if (typeof value === 'object' && value !== null && !(value instanceof File)) {
      objectToFormData(value, form, formKey); // Recurse for nested objects
    } else {
      form.append(formKey, value);
    }
  }
  return form;
}
